export function AdminModuleShell({ children, module }) {
  return (
    <section className="obc-admin-module">
      <header className="obc-admin-module__header">
        <div className="obc-admin-module__icon">{module.icon}</div>
        <div>
          <span>Admin module</span>
          <h2>{module.title}</h2>
          <p>{module.detail}</p>
        </div>
      </header>
      {children}
    </section>
  )
}

export function DashboardImage({ alt, src }) {
  if (!src) {
    return <span className="obc-dashboard__image-placeholder" aria-label={`${alt} has no uploaded image`}>No image</span>
  }

  return <img src={src} alt={alt} />
}

export function AdminTable({ title, rows, columns, imageKey, ImageComponent }) {
  return (
    <section className="tactical-card obc-admin__table-card">
      <div className="obc-admin__panel-head">
        <h2>{title}</h2>
      </div>
      <div className="obc-admin__table">
        <div className="obc-admin__table-head" style={{ '--cols': columns.length + (imageKey ? 1 : 0) }}>
          {imageKey ? <span>Image</span> : null}
          {columns.map((column) => <span key={column}>{column}</span>)}
        </div>
        {rows.map((row, index) => (
          <article className="obc-admin__table-row" style={{ '--cols': columns.length + (imageKey ? 1 : 0) }} key={`${title}-${index}`}>
            {imageKey && ImageComponent ? <ImageComponent src={row[imageKey]} alt={row.lot || row.item || title} /> : null}
            {columns.map((column) => (
              <span key={column}>{row[column]}</span>
            ))}
          </article>
        ))}
      </div>
    </section>
  )
}
